export const dataLayerPush = ({ event, ...props } = {}) => {
  // ! TODO: Should sanitize all properties
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...props });
};
